import { useQuery, useSuspenseQuery } from '@tanstack/react-query';

import { ParkAndRideFacilityDetailContent } from '@/components/map/details/content/ParkAndRideFacilityDetailContent';
import { DetailPopup } from '@/components/map/details/popup/DetailPopup';
import {
  backendApiParkAndRideFacilitiesFindOneOptions,
  backendApiParkingDataFindAllLatestParkAndRideFacilityDataOptions,
} from '@/modules/api/backend/@tanstack/react-query.gen';
import { FeatureType } from '@/types/FeatureType';
import { MapLayer } from '@/types/MapLayer';

interface ParkAndRideFacilityPopupContentProps {
  id: string;
}

export function ParkAndRideFacilityPopup({ id }: ParkAndRideFacilityPopupContentProps) {
  const { data: parkAndRideFacility } = useSuspenseQuery(
    backendApiParkAndRideFacilitiesFindOneOptions({
      path: { parkAndRideFacilityId: id },
    }),
  );

  const { data: parkAndRideFacilityData } = useQuery({
    ...backendApiParkingDataFindAllLatestParkAndRideFacilityDataOptions(),
    select: (data) => data.find((item) => item.id === id),
  });

  if (!parkAndRideFacility.geometry) {
    return null;
  }

  return (
    <DetailPopup
      id={id}
      mapLayer={parkAndRideFacility.stationId ? MapLayer.PARK_AND_RIDE_FACILITY : MapLayer.PARKING_FACILITY}
      point={parkAndRideFacility.geometry}
      title={parkAndRideFacility.name}
      type={FeatureType.PARK_AND_RIDE_FACILITY}
    >
      <ParkAndRideFacilityDetailContent data={parkAndRideFacilityData} facility={parkAndRideFacility} />
    </DetailPopup>
  );
}
